import { fetchWithAuth } from "@/lib/api";
import type { Asset } from "@/schemas";
import { API_BASE } from "@/config/api";

export const getAsset = async (assetId: string): Promise<Asset | null> => {
  try {
    const response = await fetchWithAuth(`${API_BASE}/assets/${assetId}`);
    if (!response.ok) {
      if (response.status === 404) return null;
      throw new Error(`Failed to fetch asset ${assetId}`);
    }
    const data = await response.json();
    return data.asset || data;
  } catch (error) {
    console.error(`Error fetching asset ${assetId}:`, error);
    return null;
  }
};
